(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.re-new-investment.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.controller :as
    portfolio-locations]))

(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:holding-name       (get-in report-data [:holding-name])
   :reference-date     (get-in report-data [:reference-date])
   :report-id          (:report-id props)
   :case-overview-text (report-ctl/rich-content
                        props
                        :case-overview-text)
   :overview           (report-ctl/with-footnote
                        props
                        :overview-figures-footnotes
                        (get-in report-data [:basic-information-primary]))
   :map-data           (report-ctl/with-footnote
                        props
                        :map-data-footnotes
                        (portfolio-locations/portfolio-locations map-topo
                                                                 (get-in report-data
                                                                         [:chart-data-map])))})
